import React from 'react';

interface IState {
  title: string;
}

interface IContext extends IState {
  title: string;
  setTitle: (title: string) => void;
}

enum ContextAction {
  SetTitle = 'setTitle',
}

type Payload = {
  [ContextAction.SetTitle]: { title: string };
};

const initialState: IState = {
  title: '',
};

const initialContext: IContext = {
  ...initialState,
  setTitle: () => {},
};

function reducer(state: IState, action: Action<Payload>): IState {
  switch (action.type) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    case ContextAction.SetTitle:
      return {
        ...state,
        title: action.title,
      };
    default:
      return state;
  }
}

const PageContext = React.createContext<IContext>(initialContext);

const PageContextProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const setTitle = (title: string) =>
    dispatch({ type: ContextAction.SetTitle, title });

  return (
    <PageContext.Provider value={{ title: state.title, setTitle }}>
      {children}
    </PageContext.Provider>
  );
};

const usePageContext = () => React.useContext(PageContext);

export { PageContextProvider, usePageContext };
